import React from 'react';
import './../../../pages/Organizador/Tela_Login_Organizador/style.css';
import api from './../../../services/api';
import { login } from '../../../services/Auth';
import { withRouter } from 'react-router';
import { NavLink } from 'react-router-dom';
import { authenticate } from './../../../services/api'
let apiAuthenticate = new authenticate();
class Forms_OGLogin extends React.Component {

    constructor() {
        super();
        this.state = {
            email: "",
            password: "",
        };
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(evt) {
        this.setState({ [evt.target.name]: evt.target.value });
    }
    handleSubmit = evt => {
        evt.preventDefault();

        const agent = {
            email: this.state.email,
            password: this.state.password,
        };

        if (!agent.email || !agent.password) {
            this.setState({ error: "Preencha e-mail e senha para continuar!" });
            console.log('Preencha e-mail e senha para continuar!')
        } else {
            apiAuthenticate.ProfessionalLogin(agent)
            .then(res => {
                console.log(res);
                console.log(res.data);
                console.log(agent);
                login(res.data.token, res.data._id);
                this.props.history.push("/Tela_OG");
            }
            ).catch(error => {
                alert("E-mail ou Senha incorretos!")
            })
        }
    }
    render() {
        return (
            <form onSubmit={this.handleSubmit} id="forms-OG-Login">
                <input onChange={this.handleChange} name="email" placeholder="E-mail" id="OG-Login" />
                <input onChange={this.handleChange} name="password" type="password" placeholder="Senha" id="OG-Login" />
                <button onClick={() => this.handleSubmit} id="OG-Login">Fazer Login</button>
                <NavLink to="/Tela_RedefinirSenha" className="navlink-padrao-style"><p className="btn-fp-main">Esqueci a Senha</p></NavLink>
            </form>
        );
    }
}
Forms_OGLogin = withRouter(Forms_OGLogin);
export default Forms_OGLogin;